import React, { FC, Fragment, MouseEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Tooltip } from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { Order } from 'models/order';
import { currentOrgVar } from 'apollo/reactive-variables/organization';
import { toggleTruckIconTemplate } from 'apollo/templates/order/mutation.graphql';
import { useMutation } from '@apollo/client';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';

type TruckIconButtonProps = {
    order: Order;
    onDenthubTransportToggle: (order: Order) => void;
};
const TruckIconButton: FC<TruckIconButtonProps> = ({ order, onDenthubTransportToggle }: TruckIconButtonProps) => {
    const { t: translate } = useTranslation(['orders']);
    const currentOrganization = currentOrgVar();
    const [isRequestHandled, setIsRequestHandled] = useState(order.deliveryDetails.isLabHandleRequest);
    const { showBoundary } = useDenthubErrorBoundary();

    useEffect(() => {
        setIsRequestHandled(order.deliveryDetails.isLabHandleRequest);
    }, [order]);

    const [toggleTruckIcon, { loading }] = useMutation(toggleTruckIconTemplate, {
        onError(error) {
            showBoundary(error);
        },
    });

    const handleButtonClick = async (event: MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        if (currentOrganization.isTransportEnable && !order.deliveryDetails.isLabHaveOwnResource) {
            onDenthubTransportToggle(order);
            return;
        }
        setIsRequestHandled(!isRequestHandled);
        await toggleTruckIcon({
            variables: { _id: order._id, truckValue: !isRequestHandled, isLabHaveOwnResource: false },
        });
    };

    return (
        <Fragment>
            <Tooltip
                title={
                    <span>
                        {isRequestHandled
                            ? translate('orders:TRANSPORT_SCHEDULED')
                            : translate('orders:NO_TRANSPORT_SCHEDULED')}
                    </span>
                }
            >
                <IconButton size="small" onClick={handleButtonClick} disabled={loading}>
                    <LocalShippingIcon
                        sx={{
                            color: isRequestHandled ? 'success.main' : 'focus.main',
                        }}
                    />
                </IconButton>
            </Tooltip>
        </Fragment>
    );
};

export default TruckIconButton;
